<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 16:53:09
 * @LastEditTime: 2019-08-26 18:03:51
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="container">
    <el-form ref="form" :model="form" label-width="150px" :inline="true" class="mt20">
      <!-- <el-form-item label="添加时间" style="text-align: center">
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="开始时间"
            v-model="form.start"
            style="width: 100%"
          ></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="结束时间"
            v-model="form.end"
            style="width: 100%"
          ></el-date-picker>
        </el-col>
      </el-form-item> -->
      <el-form-item label="经销商/业务员编号:">
        <el-input v-model="form.dealer_sn" clearable></el-input>
      </el-form-item>
      <el-form-item label="经销商/业务员名称:">
        <el-input v-model="form.dealer_name" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch()">搜索</el-button>
        {{ expense_num_list1 }}
      </el-form-item>
    </el-form>
    <!--表格-->
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      stripe
      v-loading="loading"
      height="350"
      style="width: 100%"
    >
      <el-table-column label="经销商/业务员编号" width="140" prop="dealer_sn" fixed>
      </el-table-column>
      <el-table-column prop="dealer_name" label="经销商/业务员名称" fixed>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号码" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="type" label="身份类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="product_name" label="状态" show-overflow-tooltip width="60">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">正常</span>
          <span v-if="scope.row.status == 2">禁用</span>
        </template>
      </el-table-column>
      <el-table-column prop="expense_num" label="申报数量" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ expense_num_list[scope.row.id] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="expensedetail(scope.row)"
            >申报明细</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      style="margin: 20px 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNo"
      :page-sizes="[5, 50, 100, 200]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalSize"
    >
    </el-pagination>
    <!--报销明细-->
    <selectDealerExpenseDetail
      :detailData="salesman_id"
      @update-message="updateMessage"
      v-if="selectDED"
      v-on:handleClose="selectDED = false"
    />
  </div>
</template>

<script>
import selectDealerExpenseDetail from "@/common/selectDealerExpenseDetail";
export default {
  name: "lowerexpensemanage",
  data() {
    return {
      salesman_id: "", //查看申报明细传递经销商业务员编号
      selectDED: false,
      loading: false,
      deliverDialog: false,
      form: {
        region_city: "",
        region_province: "",
        region_city: "",
        region_country: "",
        store_img: [],
      },
      storeList: [],
      tableData: [],
      //分页
      pageNo: 1,
      pageSize: 5,
      totalSize: 0,
      dealerLevel: [], //经销商级别,
      form1: {
        from_sn: "",
        dealer_name: "",
        from_level_id: "",
      },
      countrys: [],
      provinces: [],
      citys: [],
      areas: [],
      expense_num_list: [],
    };
  },
  methods: {
    //申报明细
    expensedetail(row) {
      this.salesman_id = row.id;
      this.selectDED = true;
    },
    //响应式更新申报数量
    updateMessage(id, expense_num) {
      this.expense_num_list[id] = this.expense_num_list[id] - expense_num;
      this.$set(
        this.expense_num_list,
        this.expense_num_list.length,
        this.expense_num_list[id]
      );
    },
    // 获取四级联动
    getcountry() {
      this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
        type: 1,
        parent_id: "",
      })
        .then((res) => {
          this.countrys = res.data;
          this.citys = [];
          this.areas = [];
          this.provinces = [];
        })
        .catch((error) => {});
    },
    getprovinces() {
      this.citys = [];
      this.provinces = [];
      this.areas = [];
      this.form.region_province = "";
      this.form.region_city = "";
      this.form.region_area = "";
      this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
        type: 2,
        parent_id: this.form.region_country,
      })
        .then((res) => {
          this.provinces = res.data;
        })
        .catch((error) => {});
    },
    getcity() {
      this.$forceUpdate();
      this.citys = [];
      this.areas = [];
      this.form.region_city = "";
      this.form.region_area = "";
      this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
        type: 3,
        parent_id: this.form.region_province,
      })
        .then((res) => {
          this.citys = res.data;
        })
        .catch((error) => {});
    },
    getArea() {
      this.$forceUpdate();
      this.areas = [];
      this.form.region_area = "";
      this.$get("logistics_2", "/vstore/dealer_pc/regionlist", {
        type: 4,
        parent_id: this.form.region_city,
      })
        .then((res) => {
          this.areas = res.data;
        })
        .catch((error) => {});
    },

    getStoreLevel() {
      this.$get("logistics_2", "/vstore/dealer_pc/dealerlevel")
        .then((res) => {
          this.storeList = res.data;
        })
        .catch((error) => {});
    },
    // 所辖门店集合
    lowerStoreList(data) {
      this.$router.push({
        name: "lowerStoreManage",
        query: {
          id: data.id,
        },
      });
    },
    // 查看详情
    detail(data) {
      this.$router.push({
        name: "lowerStoreManage",
        query: {
          id: data.id,
        },
      });
    },
    edit(data) {
      this.$router.push({
        name: "addDealer",
        query: {
          edit: data.id,
        },
      });
    },
    //选择经销商
    getDealerInfo(val) {
      this.form1.from_sn = val.dealer_sn;
      this.form1.dealer_name = val.dealer_name;
    },
    //请求列表数据
    onSearch() {
      this.loading = true;
      let beginstr = "",
        endstr = "";
      if (this.form.start) {
        beginstr = this.moment(this.form.start).format("YYYY-MM-DD");
      }
      if (this.form.end) {
        endstr = this.moment(this.form.end).format("YYYY-MM-DD");
      }
      this.$get("logistics_2", "/vstore/dealer_pc/lowerExpenseList", {
        lang: "",
        ...this.form,
        per_page: this.pageSize,
        page: this.pageNo,
        start_time: beginstr,
        end_time: endstr,
      })
        .then((res) => {
          this.loading = false;
          this.tableData = res.data.data;
          this.totalSize = res.data.total;
          this.expense_num_list = [];
          this.tableData.forEach((element, idx) => {
            this.expense_num_list[element.id] = element.expense_num;
          });
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },
    /*分页*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.onSearch();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.onSearch();
    },
    //添加入库
    add() {
      this.$router.push({
        name: "addDealer",
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //发货
    deliver(row) {
      this.deliverDialog = true;
    },
    //删除
    disables(row, temp) {
      if (temp == 2) {
        this.$confirm("是否禁用该经销商?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var url = "/vstore/dealer_pc/setdealerstatus";
            this.$get("logistics_2", url, {
              id: row.id,
              status: temp,
            })
              .then((res) => {
                if (res.code == 1) {
                  this.$message({
                    type: "success",
                    message: "禁用成功!",
                  });
                  this.onSearch();
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消禁用",
            });
          });
      } else if (temp == 3) {
        this.$confirm("是否删除该经销商?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var url = "/vstore/dealer_pc/setdealerstatus";
            this.$get("logistics_2", url, {
              id: row.id,
              status: temp,
            })
              .then((res) => {
                if (res.code == 1) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.onSearch();
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$confirm("是否启用该经销商?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            var url = "/vstore/dealer_pc/setdealerstatus";
            this.$get("logistics_2", url, {
              id: row.id,
              status: temp,
            })
              .then((res) => {
                if (res.code == 1) {
                  this.$message({
                    type: "success",
                    message: "启用成功!",
                  });
                  this.onSearch();
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消启用",
            });
          });
      }
    },
  },
  created() {
    this.onSearch();
    this.getStoreLevel();
    this.getcountry();
  },
  components: {
    selectDealerExpenseDetail,
  },
};
</script>
<style lang="scss" scoped></style>
